import React from 'react';
import styles from './OfflineBanner.module.css';

interface OfflineBannerProps {
  queueCount: number;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({ queueCount }) => {
  return (
    <div className={styles.offlineBanner}>
      <div className={styles.content}>
        <span className={styles.icon}>📵</span>
        <div className={styles.text}>
          <span className={styles.title}>Offline Mode</span>
          <span className={styles.subtitle}>
            {queueCount > 0 
              ? `${queueCount} expense${queueCount > 1 ? 's' : ''} queued for sync`
              : 'You can still add expenses - they\'ll sync when online'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfflineBanner;

